<script lang="ts" setup>
</script>

<template>
  <v-app id="ui-app">
    <router-view></router-view>
    <div id="notification-dialog-modal"></div>
  </v-app>
</template>

<style lang="scss">
* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}

html {
  font-size: 14px;
  font-family: "Montserrat" !important;
}

#ui-app{
  font-size: 14px;
  font-family: "Montserrat";
  background-color: #F3F4FA !important;

}

#app {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  max-width: 100%;
  position: relative;
  font-family: "Montserrat";
  --main-color: #5d58b7;
  color: var(--v-body-color);
}

.v-list {
  background: transparent;

  .v-list-item {
    &.default-menu-item {
      min-height: 30px;
      cursor: pointer;
      border-radius: 4px;
      color: var(--v-app-list-item-color);
      transition: all 0.25s ease-in;

      .v-list-item__prepend>.v-icon {
        -webkit-margin-end: 15px;
        margin-inline-end: 15px;
        font-size: 16px;
      }

      .v-list-item-title {
        font-size: 14px;
      }

      .v-list-item__overlay {
        background: transparent;
      }

      &:hover {
        background: var(--v-theme-hover-color);
        color: var(--v-app-list-item-active-color);
      }

      &:not(:last-child) {
        margin-bottom: 4px;
      }
    }
  }
}

.tir-drag_grabbing {
  z-index: 1000;
}

.customDarkTheme {
  --v-map-point-background: #1c1a38;
  --v-map-point-title-color: #fff;
  --v-map-point-description-color: rgb(255, 255, 255, 0.5);
  --v-map-point-box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.08);
}

.customLightTheme {
  --v-map-point-background: #fff;
  --v-map-point-title-color: #000;
  --v-map-point-description-color: rgb(0, 0, 0, 0.5);
  --v-map-point-box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.08);
}

.slide-x-enter-active,
.slide-x-leave-active {
  transition: transform 0.3s cubic-bezier(0.25, 0.8, 0.5, 1), opacity 0.3s;
  opacity: 1;
}

.slide-x-enter-from,
.slide-x-leave-to {
  opacity: 0;
}

.slide-x-enter-from {
  transform: translateX(100px);
}

.slide-x-leave-to {
  transform: translateX(-100px);
}

.v-container{
  width: 100%;
  margin-right: auto;
  margin-left: auto;
  @media (max-width: 960px) {
    margin-right:10px;
    margin-left: 10px;
  }
  @media (min-width: 960px) {
    max-width: 900px !important;
  }
  @media (min-width: 1280px) {
    max-width: 1200px!important;
  }
  @media (min-width: 1440px) {
    max-width: 1264px!important;
  }
}
.container{
  width: 100%;
  margin-right: auto;
  margin-left: auto;
  @media (max-width: 960px) {
    margin-right:10px;
    margin-left: 10px;
  }
  @media (min-width: 960px) {
      max-width: 900px;
  }
  @media (min-width: 1280px) {
      max-width: 1200px;
  }
  @media (min-width: 1440px) {
    max-width:  1264px;
  }
}
.margin-l-r {
  margin-right: 91px;
  margin-left: 91px;

  @media(max-width: 1280px) {
    margin-right: 50px;
    margin-left: 50px;
  }
  @media(max-width: 992px) {
    margin-right: 0;
    margin-left: 0;
  }
}
.margin-l {
  margin-left: 91px;

  @media(max-width: 1280px) {
    margin-left: 50px;
  }
  @media(max-width: 992px) {
    margin-left: 0;
  }
}

</style>
